import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { EstablishmentsService } from '../../../services/establishments.service';
import { StorageService } from '../../../services/storage.service';
import { OfferService } from '../../../services/offer.service';

@Component({
  selector: 'app-offer-list',
  templateUrl: './offer-list.component.html',
  styleUrls: ['./offer-list.component.scss']
})
export class OfferListComponent implements OnInit {

  loading = true;
  partner = null;
  activeAccount;
  offerBase = {
    title: '',
    term: '',
    allya_offer: true,
    state: 'blocked',
    contact: { phone: '', email: '', name: '' },
    purchase_value: 0,
    purchase_economy: 0
  };

  constructor(
    private userService: UserService,
    private storage: StorageService,
    private establishmentsService: EstablishmentsService,
    private offerService: OfferService,
  ) {
  }

  ngOnInit() {
    this.activeAccount = this.userService.getLoggedAccount();
    this.getEstablishment();
  }

  getEstablishment() {
    const loginData = this.userService.getLoggedUser();
    const establishmentAccount = this.userService.getLoggedAccount();

    this.offerBase.contact = { phone: loginData.phone, email: loginData.email, name: loginData.name };

    this.establishmentsService
      .getEstablishmentInfo(establishmentAccount.id)
      .then(partner => {

        partner.applications_offer = this.offerService.getActiveOffers().map(el => {
          const existingOffer = partner.applications_offer && partner.applications_offer
            .find(offerElement => offerElement.application_slug === el.application_slug);

          const offer = existingOffer ? existingOffer : this.offerService.getSmallOffer(el.application_slug);

          return { ...this.offerBase, ...offer };
        });

        partner.offer.application_slug = 'allya';
        partner.offer.application_name = 'Allya';

        this.partner = partner;
        this.loading = false;
      });
  }

  updateOffers(offers) {
    this.partner.applications_offer = offers;
  }
}
